module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Socks-45c627900224d1bba8501be7a78a73aed4c0be75975c29db03a8e5d8b4251e64.svg";